import { FC } from "react";


export type TTitledTypedChild = {
    title: string,
    typeName: string,
    children: JSX.Element | JSX.Element[];
};

export const TitledTypedChild: FC<TTitledTypedChild> = ({ children }: TTitledTypedChild) => {
    return (
        <>
            {children}
        </>
    );
}